// import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, Stack } from '@mui/material';
// import React, { useMemo, useState } from 'react';
// import MDButton from 'components/MDButton';
// import { useLocation, useNavigate } from 'react-router-dom';

// function hasAnyValue(obj) {
//   for (const key in obj) {
//     if (obj.hasOwnProperty(key) && (
//       (typeof obj[key] === 'object' && hasAnyValue(obj[key])) ||
//       (typeof obj[key] !== 'object' && obj[key] !== '')
//     )
//     ) {
//       return true;
//     }
//   }
//   return false;
// }

// export default function FilterTraits(props = {}) {

//   const location = useLocation();
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({ activeTraits: ''});
//   const { applyTraitFilter } = props;

//   const clearAllHandler = () => {
//     setFormData({ activeTraits: '' });
//     navigate('/product_traits');
//     applyTraitFilter({});
//   };

//   const showApplyButton = useMemo(() => {
//     return hasAnyValue(formData);
//   }, [formData]);

//   const applyFiltersHandler = () => {
//     const { activeTraits } = formData || {};
//     let queryPayload = {
//       status: activeTraits,
//     };
//     if (queryPayload.status === 'all') {
//       queryPayload = { ...queryPayload, status: '' };
//     }
//     let url = `${location.pathname}?`;
//     Object.keys(queryPayload).forEach((key => {
//       if (typeof queryPayload[key] === 'object') {
//         url = url + `&${key}=${JSON.stringify(queryPayload[key])}`;
//       } else {
//         url = url + `&${key}=${queryPayload[key]}`;
//       }
//     }));
//     const params = new URLSearchParams(url);
//     const urlWithParams = `${location.pathname}?${params}`;
//     navigate(urlWithParams);
//     applyTraitFilter({ queryPayload });
//   };

//   return (
//     <Box className='cus-filter-sec' mb={1}>
//       <Grid className='filter-box' container alignItems='center' spacing={1.5}>
//         <Grid item xs={12} sm={12} md={12} xxl={12}>
//           <Box className='filter-price-unit'>

//             <Stack direction='row' justifyContent='flex-end' width='100%' gap={2}  >
//               <Grid item xs={12} sm={4} md={2} xxl={2}>
//                 <Box className='filter-pro-status'>
//                   <FormControl fullWidth>
//                     <InputLabel>Status</InputLabel>
//                     <Select size='small' value={formData?.activeTraits} onChange={(e) => setFormData({ ...formData, activeTraits: e.target.value })} fullWidth className='form-select' name='status' label='Product Status' >
//                       <MenuItem value='all'>All</MenuItem>
//                       <MenuItem value='Active'>Active</MenuItem>
//                       <MenuItem value='Inactive'>Inactive</MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm={4} md={4} xxl={1.5}>
//                 <Box className='filter-btns'>
//                   <Stack direction='row' alignItems='center' gap={1} className='w-100'>
//                     <Button className='filter-clear-all' onClick={clearAllHandler} size='small' variant='text' color='secondary' style={{ width: '100%' }}>
//                       Clear All
//                     </Button>
//                     <MDButton disabled={!showApplyButton} className='filter-apply' onClick={applyFiltersHandler} size='small' variant='contained' color='primary' style={{ width: '100%' }}>
//                       Apply
//                     </MDButton>
//                   </Stack>
//                 </Box>
//               </Grid>
//             </Stack>
//           </Box>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// }


import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import React, { useMemo, useState } from 'react';
import MDButton from 'components/MDButton';
import { useLocation, useNavigate } from 'react-router-dom';

function hasAnyValue(obj) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && (
      (typeof obj[key] === 'object' && hasAnyValue(obj[key])) ||
      (typeof obj[key] !== 'object' && obj[key] !== '')
    )
    ) {
      return true;
    }
  }
  return false;
}

export default function FilterTraits(props = {}) {

  const location = useLocation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ selectedPlatform: '' }); // Renamed state to selectedPlatform
  const { applyTraitFilter } = props;

  const clearAllHandler = () => {
    setFormData({ selectedPlatform: '' }); // Reset to empty
    navigate('/product_traits');
    applyTraitFilter({});
  };

  const showApplyButton = useMemo(() => {
    return hasAnyValue(formData);
  }, [formData]);

  const applyFiltersHandler = () => {
    const { selectedPlatform } = formData || {}; // Changed to selectedPlatform
    let queryPayload = {
      platformType: selectedPlatform, // Use platforms instead of activeTraits
    };
    if (queryPayload.platformType === 'all') {
      queryPayload = { ...queryPayload, platformType: '' };
    }
    let url = `${location.pathname}?`;
    Object.keys(queryPayload).forEach((key => {
      if (typeof queryPayload[key] === 'object') {
        url = url + `&${key}=${JSON.stringify(queryPayload[key])}`;
      } else {
        url = url + `&${key}=${queryPayload[key]}`;
      }
    }));
    const params = new URLSearchParams(url);
    const urlWithParams = `${location.pathname}?${params}`;
    navigate(urlWithParams);
    applyTraitFilter({ queryPayload });
  };

  return (
    <Box className='cus-filter-sec' mb={1}>
      <Grid className='filter-box' container alignItems='center' spacing={1.5}>
        <Grid item xs={12} sm={12} md={12} xxl={12}>
          <Box className='filter-price-unit'>
            <Stack direction='row' justifyContent='flex-start' width='100%' gap={2}>
              <Grid item xs={12} sm={4} md={2} xxl={2}>
                <Box className='filter-platform-select'>
                  <FormControl fullWidth>
                    <InputLabel>Platform</InputLabel>
                    <Select
                      size='small'
                      value={formData?.selectedPlatform} // Using selectedPlatform
                      onChange={(e) => setFormData({ ...formData, selectedPlatform: e.target.value })} // Update selectedPlatform
                      fullWidth
                      className='form-select'
                      name='platform'
                      label='Platform'
                    >
                      <MenuItem value='all'>All</MenuItem>
                      <MenuItem value='hyperwolf'>Hyperwolf</MenuItem>
                      <MenuItem value='hemp'>Hemp</MenuItem>
                      <MenuItem value='stilo'>Stilo</MenuItem>

                    </Select>
                  </FormControl>
                </Box>
              </Grid>

              <Grid item xs={12} sm={4} md={4} xxl={1.5}>
                <Box className='filter-btns'>
                  <Stack direction='row' alignItems='center' gap={1} className='w-100'>
                    <Button
                      className='filter-clear-all'
                      onClick={clearAllHandler}
                      size='small'
                      variant='text'
                      color='secondary'
                      style={{ width: '100%', fontWeight: "normal" }}
                    >
                      Clear All
                    </Button>
                    <MDButton
                      disabled={!showApplyButton}
                      className='filter-apply'
                      onClick={applyFiltersHandler}
                      size='small'
                      variant='contained'
                      color='primary'
                      style={{ width: '100%' }}
                    >
                      Apply
                    </MDButton>
                  </Stack>
                </Box>
              </Grid>
            </Stack>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
